import type LogRocket from 'logrocket';
// Configs
import { prodCfg, siteUrl } from 'configs/apiConfig';

type TLogRocket = typeof LogRocket;
interface IIdentity {
  id: string;
  traits: { name: string; email: string };
}

// Session recording runs on production only. Initialised once per page load: the React plugin adds
// document listeners, so running it again on every user change stacked them.
const isLogRocketEnabled = siteUrl === prodCfg?.siteUrl;

let recorder: Promise<TLogRocket> | undefined;
// The user can sign in before the recorder has loaded: the last identity is applied when it has.
let identity: IIdentity | undefined;

const applyIdentity = (LogRocket: TLogRocket) =>
  identity && LogRocket.identify(identity.id, identity.traits);

/** Fetches and starts LogRocket after first paint, so its 56 KB are not in the first-load chunk. */
export const loadLogRocket = () => {
  if (!isLogRocketEnabled || recorder) {
    return;
  }

  recorder = Promise.all([import('logrocket'), import('logrocket-react')]).then(
    ([{ default: LogRocket }, { default: setupLogRocketReact }]) => {
      LogRocket.init('wzx0tr/timego');
      setupLogRocketReact();
      applyIdentity(LogRocket);
      return LogRocket;
    },
  );
  // A blocked chunk leaves recording off; the app must not notice.
  recorder.catch(() => undefined);
};

/** Tags the LogRocket session with the signed-in user. */
export const identifyLogRocketUser = (id: string, traits: IIdentity['traits']) => {
  if (!isLogRocketEnabled) {
    return;
  }

  identity = { id, traits };
  recorder?.then(applyIdentity).catch(() => undefined);
};
